// extracted by mini-css-extract-plugin
export var addButton = "_3x-d";
export var bullets = "_3x-e";
export var compact = "_3x-2";
export var container = "_3x-j";
export var extendedWarrantyModal = "_3x-f";
export var learn = "_3x-l";
export var learnMore = "_3x-g";
export var offeringOption = "_3x-3";
export var offeringPrice = "_3x-8";
export var offeringSubtitle = "_3x-7";
export var offeringTitle = "_3x-6";
export var offeringsContainer = "_3x-0";
export var pdpTilesBackground = "_3x-n";
export var plan = "_3x-m";
export var regular = "_3x-1";
export var remove = "_3x-k";
export var seeDetailsIcon = "_3x-i";
export var seeDetailsLink = "_3x-h";
export var selectedOption = "_3x-4";
export var shieldIcon = "_3x-b";
export var shieldIconCompact = "_3x-c";
export var subtitle = "_3x-a";
export var title = "_3x-9";
export var unselectedOption = "_3x-5";